import { useRef, useCallback } from 'react'

/**
 * Returns a debounced version of the given callback.
 * Each call resets the timer; the callback fires after `delay` ms of inactivity.
 */
export function useDebounce<T extends (...args: any[]) => void>(
  callback: T,
  delay: number,
): T {
  const timerRef = useRef<ReturnType<typeof setTimeout>>()

  return useCallback(
    ((...args: any[]) => {
      if (timerRef.current) clearTimeout(timerRef.current)
      timerRef.current = setTimeout(() => callback(...args), delay)
    }) as unknown as T,
    [callback, delay],
  )
}

export default useDebounce
